import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "row justify-around items-center content-center q-py-xs" }

import TenantInfo from '@/components/TenantInfo.vue';
import BrandDrawer from '@/components/BrandDrawer.vue';
import { TenantLite } from '../store/models';
import tenantModule from '@/store/modules/tenantModule';
import colors from 'quasar/src/utils/colors/colors.js';import setCssVar from 'quasar/src/utils/css-var/set-css-var.js';import useQuasar from 'quasar/src/composables/use-quasar/use-quasar.js';;

import { defineComponent, ref,onMounted, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'CompactLayout',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const store = useStore();
const $q = useQuasar();
const { t, locale } = useI18n();


const name = ref<string>('CompactLayout');
const tenantLite = ref<TenantLite | null>(null);
const rightDrawerOpen = ref<boolean>(false);

  onMounted(async () => {
    loadTenantInfoLite();
  });

 async function loadTenantInfoLite() {
    try {
      tenantLite.value = tenantModule.tenantInfoLite || null;
      if (!tenantLite.value) {
        await tenantModule.loadTenantInfoLite();
        tenantLite.value = tenantModule.tenantInfoLite;
        if (tenantLite.value && tenantLite.value.primaryColor) {
          setCssVar('primary', tenantLite.value.primaryColor)
        }
        if (tenantLite.value && tenantLite.value.secondaryColor) {
          setCssVar('secondary', tenantLite.value.secondaryColor)
        } else {
          setCssVar('secondary', '#6ab0ea')
        }

        if (tenantLite.value && tenantLite.value.primaryTextColor) {
          setCssVar(
            'default-sent-chat-text-color',
            tenantLite.value.primaryTextColor
          );

        } else {
          setCssVar('default-sent-chat-text-color', '#fff');
        }

        if (tenantLite.value && tenantLite.value.secondaryTextColor) {
          setCssVar(
            'default-receive-chat-text-color',
            tenantLite.value.secondaryTextColor
          );
        } else {
          setCssVar('default-receive-chat-text-color', '#000');
        }
      }
    } catch (error) {
      console.log(error);
    }
    if (!tenantLite.value) {
      router.push({ name: 'invalidtenant' });
    }
  }


return (_ctx: any,_cache: any) => {
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_header = _resolveComponent("q-header")!
  const _component_q_drawer = _resolveComponent("q-drawer")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_q_page_container = _resolveComponent("q-page-container")!
  const _component_q_layout = _resolveComponent("q-layout")!

  return (_openBlock(), _createBlock(_component_q_layout, {
    view: "hhh lpR fff",
    class: "shadow-3"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_header, {
        elevated: "",
        class: "primary text-white"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_toolbar_title, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    (tenantLite.value && tenantLite.value.logo && '' != tenantLite.value.logo)
                      ? (_openBlock(), _createBlock(_component_q_img, {
                          key: 0,
                          src: tenantLite.value.logo,
                          class: "logoImage",
                          contain: ""
                        }, null, 8, ["src"]))
                      : (_openBlock(), _createBlock(TenantInfo, {
                          key: 1,
                          tenantLite: tenantLite.value
                        }, null, 8, ["tenantLite"]))
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_q_btn, {
                dense: "",
                flat: "",
                round: "",
                icon: "menu",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (rightDrawerOpen.value = !rightDrawerOpen.value))
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_q_drawer, {
        modelValue: rightDrawerOpen.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((rightDrawerOpen).value = $event)),
        side: "right",
        elevated: "",
        behavior: "mobile"
      }, {
        default: _withCtx(() => [
          _createVNode(BrandDrawer, { showTermsOfUse: true })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_q_page_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})